export default __webpack_public_path__ + "static/media/therapeutique.18df73f7.svg";